const VISITOR_ID_KEY = 'gd_visitor_id';

const generateUuid = (): string => {
  try {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
      return crypto.randomUUID();
    }
  } catch {
    /* crypto unavailable */
  }
  let uuid = '';
  const chars = '0123456789abcdef';
  for (let i = 0; i < 36; i++) {
    if (i === 8 || i === 13 || i === 18 || i === 23) {
      uuid += '-';
    } else if (i === 14) {
      uuid += '4';
    } else if (i === 19) {
      uuid += chars[(Math.random() * 4 + 8) | 0];
    } else {
      uuid += chars[(Math.random() * 16) | 0];
    }
  }
  return uuid;
};

let inMemoryVisitorId: string | null = null;

export const getVisitorId = (): string => {
  try {
    const existing = window.localStorage.getItem(VISITOR_ID_KEY);
    if (existing) return existing;
    const created = generateUuid();
    window.localStorage.setItem(VISITOR_ID_KEY, created);
    return created;
  } catch {
    if (!inMemoryVisitorId) inMemoryVisitorId = generateUuid();
    return inMemoryVisitorId;
  }
};

export default getVisitorId;
